<template>
	<div class="container">
		<div class="calendar">
			<div v-if="!loaded" class="loader_wrap">
				<span class="loader loader--large"></span>
			</div>
			<transition name="fade">
				<div v-if="loaded">
					<div class="calendar__controls">
						<span
							class="calendar__control calendar__control--prev"
							@click="previousMonth"
						>
							<svg
								id="Layer_1"
								data-name="Layer 1"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 152.27539 233.84033"
							>
								<defs></defs>
								<title>Previous month</title>
								<polygon
									class="cls-1"
									points="116.92 0 152.275 35.355 70.711 116.92 152.275 198.485 116.92 233.84 0 116.92 116.92 0"
								/>
							</svg>
						</span>
						<span class="calendar__control calendar__control--next" @click="nextMonth"
							><svg
								id="Layer_1"
								data-name="Layer 1"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 152.27539 233.84033"
							>
								<defs></defs>
								<title>Next month</title>
								<polygon
									class="cls-1"
									points="35.355 233.84 0 198.485 81.564 116.92 0 35.355 35.355 0 152.275 116.92 35.355 233.84"
								/></svg
						></span>
					</div>
					<div class="events">
						<div
							:class="[
								'calendar__month',
								{
									active: isMonth(post.month)
								}
							]"
							v-for="post in eventsThis"
							:key="post.month"
						>
							<h2 :class="['calendar__month_title', { active: isMonth(post.month) }]">
								<!-- {{
									moment()
										.month(post.month - 1)
										.format('MMMM') +
										' ' +
										moment()
											.month(post.month)
											.format('YYYY')
								}} -->
								{{
									moment()
										.month(post.month - 1)
										.format('MMMM') +
										' ' +
										moment()
											.month(post.month - 1)
											.format('YYYY')
								}}
							</h2>

							<div v-for="event in post.data" :key="event.identifier">
								<Event :eventData="event" />
							</div>
						</div>
						<div
							:class="[
								'calendar__month',
								{
									active: isMonth(
										moment()
											.month(post.month)
											.format('MMMM')
									)
								}
							]"
							v-for="post in eventsNext"
							:key="'next' + post.month"
						>
							<h2 :class="['calendar__month_title', { active: isMonth(post.month) }]">
								{{
									moment()
										.month(post.month - 1)
										.format('MMMM') +
										' ' +
										moment()
											.add(1, 'year')
											.month(post.month - 1)
											.format('YYYY')
								}}
							</h2>

							<div v-for="event in post.data" :key="event.identifier">
								<Event :eventData="event" />
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import Event from '@/components/Event.vue';
import $ from 'jquery';

Vue.prototype.moment = moment;

export default {
	name: 'Calendar',
	components: {
		Event
	},
	data() {
		return {
			eventsThis: [],
			eventsNext: [],
			loaded: false
		};
	},
	methods: {
		previousMonth() {
			var button = $('.calendar__control--prev');
			$('.calendar__control--next').removeClass('inactive');

			$('.calendar__month.active').fadeOut(100, function() {
				var month = $(this);
				var prevMonth = month.prev('.calendar__month');
				month.removeClass('active');
				prevMonth.fadeIn(100).addClass('active');
				if (prevMonth.is('.calendar__month:first')) {
					button.removeClass('active').addClass('inactive');
				}
			});
		},
		nextMonth() {
			var button = $('.calendar__control--next');
			$('.calendar__control--prev').removeClass('inactive');

			$('.calendar__month.active').fadeOut(100, function() {
				var month = $(this);
				var nextMonth = month.next('.calendar__month');
				month.removeClass('active');
				nextMonth.fadeIn(100).addClass('active');
				if (nextMonth.is('.calendar__month:last')) {
					button.removeClass('active').addClass('inactive');
				}
			});
		},
		isMonth(month) {
			if (month == moment().format('MM')) {
				return true;
			}
		},
		groupMonths(data) {
			let months = data.reduce(function(r, o) {
				var m = o.datetime_start.split('-')[1];
				r[m]
					? r[m].data.push(o)
					: (r[m] = {
							month: m,
							data: [o]
					  });
				return r;
			}, {});

			var result = Object.keys(months).map(function(k) {
				return months[k];
			});

			result.sort(function(a, b) {
				return a.month - b.month;
			});

			return result;
		}
	},
	created: function() {
		// Alias the component instance as `vm`, so that we
		// can access it inside the promise function
		var vm = this;
		// Fetch our array of posts from an API
		fetch(
			'https://nlfchurch.churchsuite.co.uk/embed/calendar/json?date_start=' +
				moment().format('YYYY') +
				'-01-01&date_end=' +
				moment().format('YYYY') +
				'-12-31'
		)
			.then(function(response) {
				return response.json();
			})
			.then(function(data) {
				vm.eventsThis = vm.groupMonths(data);
				vm.loaded = true;
			});

		fetch(
			'https://nlfchurch.churchsuite.co.uk/embed/calendar/json?date_start=' +
				moment()
					.add(1, 'year')
					.format('YYYY') +
				'-01-01&date_end=' +
				moment()
					.add(1, 'year')
					.format('YYYY') +
				'-12-31'
		)
			.then(function(response) {
				return response.json();
			})
			.then(function(data) {
				vm.eventsNext = vm.groupMonths(data);
			});
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.calendar {
	min-height: 300px;
	position: relative;
}

.calendar__top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.calendar__month_title {
	font-size: 44px;
	font-weight: $bold;
	color: $blue;
	margin: 0 0 30px;

	&.active {
		display: block;
	}
}

.calendar__controls {
	width: 70px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: absolute;
	top: 15px;
	right: 0;
}

.calendar__control {
	width: 22px;
	display: block;

	&.inactive {
		svg {
			display: none;
		}
	}

	&:hover {
		cursor: pointer;

		svg {
			fill: $teal;
		}
	}

	svg {
		fill: #c1c3d9;
		transition: 0.2s;
	}
}

.calendar__month {
	display: none;

	&.active {
		display: block;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}

.loader--large {
	width: 70px;
	height: 70px;
	border: 5px solid $blue;
	border-right-color: transparent;
	border-top-color: transparent;
	margin: 0 auto;
	position: absolute;
	top: 50%;
	right: 0;
	left: 0;
	transform: translateY(-50%);
	opacity: 0.3;
}

@media screen and (max-width: 500px) {
	.calendar__month_title {
		font-size: 36px;
		margin: 0 0 20px;
	}

	.calendar__controls {
		width: 60px;
		top: 10px;
	}
}
</style>
